import React from 'react';
import { ChevronDownIcon, ChevronRightIcon } from 'lucide-react';
interface RouteFlowProps {
  steps: string[];
  tone?: 'light' | 'dark';
}
export function RouteFlow({
  steps,
  tone = 'light'
}: RouteFlowProps) {
  const chip = tone === 'dark' ? 'border-white/15 bg-white/10 text-white' : 'border-ink-line bg-white text-ink';
  const arrow = tone === 'dark' ? 'text-cyan-brand' : 'text-cyan-brand';
  return <ol className="mx-auto flex w-full max-w-3xl flex-col items-stretch justify-center gap-2 sm:flex-row sm:flex-wrap sm:items-center sm:gap-2.5" data-id="element-60" data-mp="dlz6uqj8bo24">
      {steps.map((step, index) => <React.Fragment key={step} data-id="element-61" data-mp="mkb7lldt828a" data-mpi={index}>
          <li className={`rounded-xl border px-4 py-3 text-center text-[12.5px] font-extrabold uppercase tracking-wide sm:px-3.5 sm:py-2.5 sm:text-[11.5px] ${chip}`} data-id="element-62" data-mp="mk2qtiekgcrt">
            {step}
          </li>
          {index < steps.length - 1 ? <li aria-hidden="true" className="flex items-center justify-center self-center" data-id="element-63" data-mp="3v04d756lrtak">
              <ChevronDownIcon className={`h-4 w-4 sm:hidden ${arrow}`} data-id="element-64" data-mp="3sg9tc1y56oiq" />
              <ChevronRightIcon className={`hidden h-4 w-4 sm:block ${arrow}`} data-id="element-65" data-mp="3ngf21xagfwx5" />
            </li> : null}
        </React.Fragment>)}
    </ol>;
}